import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type TypeFilterValueKey } from '../../../../../common/constants/filters/universal-type';

import { type typeLabels } from './messages';

export const getTypeOptionMessageKey: (
	type: keyof typeof typeLabels,
) => TypeFilterValueKey | 'all' | 'pageAndLiveDoc' = (type: keyof typeof typeLabels) => {
	let messageKey: keyof typeof typeLabels = type;
	if (type === 'page' && fg('confluence_live_pages_open_beta_trait_opted_in')) {
		messageKey = 'pageAndLiveDoc';
	}

	return messageKey;
};
